import { createFileRoute, notFound } from "@tanstack/react-router";
import { AccountModule } from "@/components/klantaccount-modules";
import { accountLabels } from "@/components/klantaccount";
import { accountHead, accountOnderdelen } from "@/lib/klantaccount-shared";
import { nieuwsQuery } from "@/lib/nieuws.functions";
export const Route = createFileRoute("/_authenticated/account/$onderdeel")({
  loader: async ({ params, context }) => {
    const onderdeel = accountOnderdelen.find((o) => o === params.onderdeel);
    if (!onderdeel) throw notFound();
    if (onderdeel === "nieuws") await context.queryClient.ensureQueryData(nieuwsQuery());
    return { onderdeel };
  },
  head: ({ loaderData }) => accountHead(loaderData ? accountLabels[loaderData.onderdeel] : "Niet beschikbaar", "Je persoonlijke gegevens en hulpmiddelen in Mijn offerto."),
  component: Onderdeel,
});
function Onderdeel() { const { onderdeel } = Route.useLoaderData(); return <AccountModule key={onderdeel} onderdeel={onderdeel} />; }